<template>
  <ca-row>
    <ca-col :size="selectColSizeMixin">
      <ca-field label="Sindicato">
        <ca-search-select
          v-model="union"
          required
          load-more
          compare-value-by="id"
          placeholder="Sem sindicato"
          :custom-validations="customValidations"
          :on-query="onQuery"
          :on-query-success="onQuerySuccess"
          :on-load-more-button-click="onLoadMore"
          :on-change="refreshForm">
          <ca-option
            v-for="option in unionsData"
            :key="option.id"
            :value="option">
            {{ option.name }}
          </ca-option>
        </ca-search-select>
      </ca-field>
    </ca-col>

    <ca-col
      v-if="shouldShowAddButtonMixin"
      size="4"
      class="ca-u-margin-top">
      <ca-button full-width @click="openCreateUnionModal">Novo sindicato</ca-button>
    </ca-col>
  </ca-row>
</template>

<script>
import { getUnions } from 'accountant/employer/unions/unionService';
import CreateUnionModal from '../../modals/CreateUnionModal';
import { workerFormMixin } from '../../mixins/WorkerFormMixin';

export default {
  name: 'WorkerUnionSelect',
  mixins: [workerFormMixin],
  props: {
    value: Object,
    refreshForm: Function,
  },
  data() {
    return {
      page: 0,
      union: this.value,
      unionsData: [],
    };
  },
  computed: {
    customValidations() {
      // TODO: a validação padrão do formulário não está sendo aplicada
      return [{
        message: 'Campo obrigatório',
        valid: value => !!value?.id,
      }];
    },
  },
  watch: {
    union({ id, name: description }) {
      this.onInputChange({ id, description });
    },
  },
  created() {
    this.onQuery().then(this.onQuerySuccess);
  },
  methods: {
    onInputChange(value) {
      this.$emit('change', value);
      this.$emit('input', value);
    },
    onQuery() {
      return getUnions({ page: this.page });
    },
    onQuerySuccess(response) {
      this.unionsData = response.content;
    },
    onLoadMore() {
      this.page++;
      this.onQuery()
        .then(response => {
          this.unionsData = this.unionsData.concat(response.content);
        });
    },
    openCreateUnionModal() {
      this.$dialogModal(CreateUnionModal, {
        on: {
          created: () => this.$refs.unionSelect.onQuery(),
        },
      }).open();
    },
  },
};
</script>
